/**
 * Échelle de border radius Odys (base 4px).
 *
 * Valeurs en strings CSS (`'12px'`) et non en nombres : dans la prop `sx`,
 * un `borderRadius` numérique est multiplié par `theme.shape.borderRadius`
 * (ex. `borderRadius: 12` → 72px). Les strings passent telles quelles.
 *
 * Usage : `sx={{ borderRadius: theme => theme.radius.lg }}` (le thème créé
 * par `createOdysTheme` expose l'échelle sous `theme.radius`).
 *
 * `pill` n'est pas le dernier cran de l'échelle mais une intention distincte :
 * « les deux extrémités sont des demi-cercles ». Réservé aux éléments dont la
 * hauteur est fixe et connue — chips de statut, pilules de filtre, badges de
 * compteur, boutons d'icône ronds. Sur une surface dont la hauteur varie (une
 * card, un panneau, un champ multiligne), il produit un rayon proportionnel au
 * contenu : prendre un cran de l'échelle (`md`…`3xl`).
 */
export const radius = {
  /** Micro-rayons : bordures de cellule, barres de progression, sparklines. */
  xs: "2px",
  sm: "4px",
  md: "8px",
  lg: "12px",
  xl: "16px",
  "2xl": "20px",
  "3xl": "24px",
  pill: "9999px",
} as const;

export type RadiusScale = typeof radius;
export type RadiusToken = keyof RadiusScale;
